module.exports = __webpack_public_path__ + "phone-preview.svg?bcb7b129a5be3f23aa2f5f219c618b13";